import { async } from '@angular/core/testing';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { FileVm } from '../../Models/fileVm';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { BaseService } from '../../Services/BaseService';
import { uploadService } from '../../uploadService';
import { distinctUntilChanged, tap } from 'rxjs/operators';

@Component({
  selector: 'app-new-file-uploader',
  templateUrl: './new-file-uploader.component.html',
  styleUrls: ['./new-file-uploader.component.scss'],
})
export class NewFileUploaderComponent implements OnInit , OnChanges {
  @Input() isMultipule: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() previousAttachments: FileVm [] = [];
  @Output() onFileUploaded: EventEmitter<any> = new EventEmitter();

  showPrevious:boolean = false

  files: File[] = [];
  isDragOver = false;

  constructor(private uploadService: uploadService) {}
  ngOnInit(): void {
    // if (this.previousAttachments) {
    //   console.log('previousAttachments', this.previousAttachments);
    // this.uploadService.MixedContent['previousAttachments'] = this.previousAttachments;
    // }
  }

  ngOnChanges() {
    if (this.previousAttachments) {
      if (this.previousAttachments.length > 0) {
        this.showPrevious = true
      }
      console.log('previousAttachments', this.previousAttachments);
      // this.uploadService.updateFiles({ files: [], previousAttachments: this.previousAttachments });
    }
  }

  isValid(){
    return this.files.length > 0 || this.previousAttachments.length > 0;
  }

  onFileSelect(event: any) {
    const selectedFiles: any[] = Array.from(event.target.files);
    if (this.isMultipule) {
      this.files.push(...selectedFiles);
      // this.onFileUploaded.emit({files:this.files , previousAttachments: this.previousAttachments})
    }
    if (!this.isMultipule) {
      this.files = [];
      this.files.push(selectedFiles[0]);
      // this.onFileUploaded.emit({files:this.files , previousAttachments: this.previousAttachments})
      this.previousAttachments = [];
    }
    this.uploadService.updateFiles({ files: this.files, previousAttachments: this.previousAttachments });
  }

  // Handles drag over
  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = true;
  }

  // Handles drag leave
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;
  }

  // Handles file drop
  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;

    if (event.dataTransfer && event.dataTransfer.files.length) {
      const droppedFiles = Array.from(event.dataTransfer.files);
      this.files.push(...droppedFiles);
      this.onFileUploaded.emit({ files: this.files, previousAttachments: this.previousAttachments });
      this.uploadService.updateFiles({ files: this.files, previousAttachments: this.previousAttachments });
    }
  }

  // Remove selected file
  removeFile(file: File) {
    this.files = this.files.filter((f) => f !== file);
    this.onFileUploaded.emit({ files: this.files, previousAttachments: this.previousAttachments });
    this.uploadService.updateFiles({ files: this.files, previousAttachments: this.previousAttachments });
  }

  removeFilepreviouslyUploaded(i) {
    this.previousAttachments = this.previousAttachments.filter((item, index) => index != i);
    this.onFileUploaded.emit({ files: this.files, previousAttachments: this.previousAttachments });
    this.uploadService.updateFiles({ files: this.files, previousAttachments: this.previousAttachments });
  }
}
